// Module
var code = `<div class="visualTrading" style="{{>position}}">
    <div class="moveseporator" on-mousedown="@this.onMouseDown(event,true)">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#moveSeparatorVertical"></use>
        </svg>
    </div>
    <div class="visualTrading-items">
        <terceraQuantityNumeric name="qtyNumeric"
                            value="{{.quantity}}"
                            account="{{accountItem}}"
                            instrument="{{.instrumentItem}}" />

        <terceraTIFComboBox orderType="{{orderTypeId}}"
                            instrument="{{instrumentItem}}"
                            items="{{items}}"
                            selectedItem="{{selectedItem}}"
                            gtdDate="{{gtdDate}}" />

        <div class="leverage" {{#if !.showLeverage}} style="display: none;" {{/if}}>
            <OELeverageSelector visible="{{showLeverage}}"
                    showLabel="false"
                    instrument="{{instrumentItem}}"
                    account="{{accountItem}}"
                    productType="{{productType}}"
                    leverageValue="{{leverageValue}}"/>
        </div>

        {{#if .isVisibleOTHTrading}}
            <terceraButton name="overnight" SVG="true" 
                    canCheck="true" checked="{{.isAllowOTHTrading}}"
                    on-btnClick="overnight_click"
                    terceraButtonStyle="button-overnight-visualtrading"/>
        {{/if}}

        <div class="js-single-OCO-btn" {{#if !.showOCObtns}} style="display: none;" {{/if}}>
            <terceraButton name="single"
                        text="{{.singleText}}"
                        canCheck="true"
                        checked={{.single_checked}}
                        on-btnClick="single_click"
                        visible="{{.showOCObtns}}"
                        terceraButtonStyle="js-button-single" />

            <terceraButton name="OCO"
                        text="{{.ocoText}}"
                        canCheck="true"
                        checked={{.OCO_checked}}
                        on-btnClick="OCO_click"
                        visible="{{.showOCObtns}}"
                        terceraButtonStyle="js-button-OCO" />
        </div>
        <div class="visualTrading-items-sub-container">
            <terceraButton name="settings" SVG="true"
                        on-btnClick="settings_click"
                        terceraButtonStyle="js-button-settings-visualtrading" />
            <terceraButton name="closeCrossBtn" SVG="true"
                        on-btnClick="closeClick"
                        terceraButtonStyle="button-close-visualtrading" />
        </div>
    </div>
</div>`;
// Exports
export default code;